(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function closeMenuDisclosure(header) {
    const disclosures = header.querySelectorAll('header-menu');
    disclosures.forEach(disclosure => disclosure.close());
  }

  function closeSearchModal(header) {
    const searchModal = header.querySelector('details-modal');
    if (searchModal) searchModal.close(false);
  }

  } catch(e) { console.error(e); }
})();
})();
